<td class="cl-td-checkbox">
  <div class="form-check text-center">
    <input class="form-check-input" type="checkbox" [checked]="selected" (change)="toggleSelection()">
  </div>
</td>
<td style="white-space: nowrap;">
  {{ poItem.po_item_id }}
</td>
<td style="max-width: 320px; white-space: normal; overflow-wrap: break-word;">
  @if (poItem.workflow_process.state == 'IN_PROGRESS') {
    @if (!poItem.checkpoint_content_complete && poItem.input_brefix.length > 1) {
      <span class="cl-badge cl-badge-sm cl-color-sky">Waiting for files</span>
    }
    @if (!poItem.checkpoint_content_complete && poItem.input_brefix == '/') {
      <span class="cl-badge cl-badge-sm cl-color-sky">Resolving Identifier</span>
    }
    @if (poItem.checkpoint_content_complete && !poItem.checkpoint_encodes_done) {
      <span class="cl-badge cl-badge-sm cl-color-sky">Encoding ...</span>
    }
    @if (poItem.checkpoint_content_complete && poItem.checkpoint_encodes_done) {
      <span class="cl-badge cl-badge-sm cl-color-sky">Encodes Done</span>
    }
  }

  @if (poItem.workflow_process.state == 'FAILED') {
    <span class="cl-badge cl-badge-sm cl-color-berry">Encode failed</span>
    <br>
    <small>{{ poItem.workflow_process.message }}</small>
  }

  @if (poItem.workflow_process.state == 'SUCCESS') {
    <span class="cl-badge cl-badge-sm cl-color-petrol">Encoded</span>
  }

  @if (poItem.workflow_process.state == 'ABORTED') {
    <span class="cl-badge cl-badge-sm cl-color-clay">Aborted</span>
  }


</td>

<td style="max-width: 320px; white-space: normal; overflow-wrap: break-word;">

  @if (poItem.publish_process?.state == 'ABORTED') {
    <span class="cl-badge cl-badge-sm cl-color-clay">Aborted</span>
  }

  @if (poItem.publish_process?.state == 'IN_PROGRESS') {
    <span class="cl-badge cl-badge-sm cl-color-sky">Publishing ...</span>
  }

  @if (poItem.publish_process?.state == 'FAILED') {
    <span class="cl-badge cl-badge-sm cl-color-berry">Publish failed</span>
    <br>
    <small>{{ poItem.publish_process.message }}</small>
  }

  @if (poItem.publish_process?.state == 'SUCCESS') {
    @switch (poItem.po_destination) {
      @case ("safran-album") {
        <span class="cl-badge cl-badge-sm cl-color-petrol">Selected</span>
      }
      @default {
        <span class="cl-badge cl-badge-sm cl-color-petrol">Published</span>
      }
    }
  }
</td>
<td>
  <div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 8px">
    @for (track of poItem.tracks; track track) {
      @if (track.codec_type == 'video') {
        <div>
          @if (track.source != null) {
            <p class="alert cl-alert-check" style="white-space: nowrap">&nbsp;</p>
          }
          @if (track.source == null && track.messages != null && track.messages.length > 0) {
            <p
              class="alert cl-alert-warning"
              style="white-space: nowrap">
            &nbsp;</p>
          }
          @if (track.source == null && track.messages != null && track.messages.length == 0) {
            <p
              class="alert cl-alert-info"
              style="white-space: nowrap">
            &nbsp;</p>
          }
        </div>
      }
    }
  </div>
</td>
<td>
  <div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 8px">
    @for (track of poItem.tracks; track track) {
      @if (track.codec_type == 'audio') {
        <div>
          @if (track.source != null) {
            <p class="alert cl-alert-check" style="white-space: nowrap">
              <small>{{ track.source.lang || track.lang }}</small></p>
          }
          @if (track.source == null && track.messages != null && track.messages.length > 0) {
            <p
              class="alert cl-alert-warning"
              style="white-space: nowrap">
                <small>{{ track.lang }}</small></p>
          }
          @if (track.source == null && track.messages != null && track.messages.length == 0) {
            <p
              class="alert cl-alert-info"
              style="white-space: nowrap">
                  <small>{{ track.lang }}</small></p>
          }
        </div>
      }
    }
  </div>
</td>
<td>
  <div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 8px">
    @for (track of poItem.tracks; track track) {
      @if (track.codec_type == 'subtitle' || track.codec_type == 'burntin_subtitle') {
        <div>
          @if (track.source != null) {
            <p class="alert cl-alert-check" style="white-space: nowrap">
                    <small>{{ track.source.lang || track.lang }}</small></p>
          }
          @if (track.source == null && track.messages != null && track.messages.length > 0) {
            <p
              class="alert cl-alert-warning"
              style="white-space: nowrap">
                      <small>{{ track.lang }}</small></p>
          }
          @if (track.source == null && track.messages != null && track.messages.length == 0) {
            <p
              class="alert cl-alert-info"
              style="white-space: nowrap">
                        <small>{{ track.lang }}</small></p>
          }
        </div>
      }
    }
  </div>
</td>
<td>
  <div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 8px">
    @for (track of poItem.tracks; track track) {
      @if (track.codec_type == 'closedcaption' || track.codec_type == 'burntin_closedcaption') {
        <div>
          @if (track.source != null) {
            <p class="alert cl-alert-check" style="white-space: nowrap">
              <small>{{ track.source.lang || track.lang }}</small></p>
          }
          @if (track.source == null && track.messages != null && track.messages.length > 0) {
            <p
              class="alert cl-alert-warning"
              style="white-space: nowrap">
              <small>{{ track.lang }}</small></p>
          }
          @if (track.source == null && track.messages != null && track.messages.length == 0) {
            <p class="alert cl-alert-info"
               style="white-space: nowrap">
              <small>{{ track.lang }}</small></p>
          }
        </div>
      }
    }
  </div>
</td>
<td>
  <div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 8px">
    @for (track of poItem.tracks; track track) {
      @if (track.codec_type == 'image') {
        <div>
          @if (track.source != null) {
            <p class="alert cl-alert-check" style="white-space: nowrap">
                              </p>
          }
          @if (track.source == null && track.messages != null && track.messages.length > 0) {
            <p
              class="alert cl-alert-warning"
              style="white-space: nowrap">
                              &nbsp;</p>
          }
          @if (track.source == null && track.messages != null && track.messages.length == 0) {
            <p
              class="alert cl-alert-info"
              style="white-space: nowrap">
                              &nbsp;</p>
          }
        </div>
      }
    }
  </div>
</td>
@if (displayMetadata) {
  <td>
    @if (poItem.checkpoint_metadata_available != null) {
      <div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 8px"
      >
        <div>
          @if (!poItem.checkpoint_metadata_available) {
            <p
              class="alert cl-alert-warning"
              style="white-space: nowrap; overflow:hidden; text-overflow:ellipsis;"> {{ poItem?.metadata_message }}
              &nbsp;</p>
          }
          @if (poItem.checkpoint_metadata_available) {
            <p
              class="alert cl-alert-check"
              style="white-space: nowrap; overflow:hidden; text-overflow:ellipsis;"></p>
          }
        </div>
      </div>
    } @else {
      <div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 8px">
        <small style="overflow:hidden; text-overflow:ellipsis;">No metadata required</small>
      </div>
    }
  </td>
}
<td class="cl-td-links">
  <a class="cl-a-btn" [routerLink]="['/o', organization()?.id, 'workflows', poItem.po.airline, poItem.po.po_name, poItem.po_item_id]">
    Details
  </a>
  @if (poItem.preview && (poItem.preview.dash_manifest_url || poItem.preview.hls_manifest_url)) {
    <a class="cl-a-btn" [routerLink]="['/o', organization()?.id, 'workflows', poItem.po.airline, poItem.po.po_name, poItem.po_item_id, 'preview']">
      Preview
    </a>
  } @else {
    <a class="disabled" >
      Preview
    </a>
  }
</td>
